// eslint-disable-next-line
import React, { useContext, useEffect, useState } from "react";
import { BsEyeSlash, BsPerson } from "react-icons/bs";
import { CiLock } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import axios from "axios";
import summaryApi from "../common/Api";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { login } from "../store/authSlice";
import { setIsAdmin } from "../store/adminSlice";
import UserContext from "../context/context";

const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const context = useContext(UserContext);

  useEffect(() => {
    context.fetchCartCount();
  },[]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsClicked(true);

    // Validate email
    // eslint-disable-next-line no-useless-escape
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailRegex.test(data.email)) {
      toast.error("Please enter a valid email address",{
        position: "top-right",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
      });
      setIsClicked(false);
      return;
    }

    // Validate password
    if (data.password.length < 8) {
      toast.error("Password must be at least 8 characters long",{
        position: "top-right",
          className: "custom-toast",
          autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
      });
      setIsClicked(false);
      return;
    }

    try {
      const dataResponse = await axios.post(summaryApi.signIn.url, data, {
        withCredentials: true,
      });

      if (dataResponse.status === 200) {
        // Set the token in cookies
        Cookies.set("tokenApi", dataResponse.data.token, {
          path: "/",
          secure: true,
          sameSite: "Strict",
          // HttpOnly cannot be set client-side, must be set server-side
        });
        // Dispatch login action
        dispatch(login(dataResponse.data.token));
       await context.fetchCartCount();
        dispatch(setIsAdmin(dataResponse.data.user.isAdmin));
        await context.fetchUserDetails();
        navigate("/");
        toast.success("Login Successfully",{
          position: "bottom-center",
            className: "custom-toast",
            autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
        });
      }
    } catch (error) {
      toast.error("Invalid email or password",{
        position: "top-right",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
      });
    } finally {
      setIsClicked(false); // Reset the button state
    }
  };

  const handleChangeData = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  return (
    <div className="bg-white container w-[320px] md:w-[400px] mx-auto flex items-center justify-center flex-col max-w-md my-[20px] rounded-[10px] h-full ">
      <div className="flex flex-col items-center justify-center">
        <h1
          style={{ fontWeight: "bold", fontSize: "30px" }}
          className="p-[20px]"
        >
          Login
        </h1>
      </div>
      <form
        className="flex flex-col self-start p-5 w-[100%]"
        onSubmit={handleSubmit}
      >
        <label className="text-sm" htmlFor="email">
          Email
        </label>
        <div className="flex items-center justify-between">
          <span className="cursor-pointer">
            <BsPerson />
          </span>
          <input
            className="w-[100%] p-[15px] outline-none"
            type="email"
            name="email"
            id="email"
            placeholder="Enter Your Email"
            onChange={handleChangeData}
            required
            value={data.email}
          />
        </div>
        <hr className="bg-main-background h-[0.1rem] mb-[15px] mt-[5px]" />
        <label className="text-sm" htmlFor="password">
          Password
        </label>
        <div className="flex items-center justify-between">
          <span className="cursor-pointer">
            <CiLock />
          </span>
          <input
            className="w-[100%] p-[15px] outline-none"
            type={showPassword ? "text" : "password"}
            name="password"
            value={data.password}
            id="password"
            placeholder="Enter Your Password"
            onChange={handleChangeData}
            onBlur={(e) => {
              if (e.target.value === "") {
                setShowPassword(false);
              }
            }}
          />
          <span
            className="cursor-pointer"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <BsEyeSlash /> : <FaEye />}
          </span>
        </div>
               <hr className="bg-main-background h-[0.1rem] mb-[15px] mt-[5px]" />

       
        <button
          type="submit"
          disabled={isClicked}
          className="flex items-center justify-center bg-main-background text-white p-[15px] w-[100%] h-[15px] mb-[5px] mt-[5px] rounded-full"
        >
          LOGIN
        </button>
        <div className="mx-auto text-gray-500 my-[15px] text-center">
          <p className="w-[100%] mb-[10px]">Have Not Account Yet?</p>
          <Link
            to="/sign-up"
            className="mx-auto text-main-background hover:underline"
          >
            Sign Up
          </Link>
        </div>
      </form>
    </div>
  );
};

export default SignIn;
